import {
  ANALYZE_EMMIT_EVENT_TO_TEALIUM,
  ANALYZE_EMMIT_VIEW_TO_TEALIUM,
  ANALYZE_EVENT,
  ANALYZE_VIEW,
} from 'b2b-apps/shop/analytics/redux/tealium/actionTypes';
import {
  AnalyzeEmmitEventToTealiumAction,
  AnalyzeEmmitViewToTealiumAction,
  AnalyzeEventAction,
  AnalyzeViewAction,
} from 'b2b-apps/shop/analytics/redux/tealium/types';

const analyzeEvent = (data: Record<string, any>): AnalyzeEventAction => ({
  type: ANALYZE_EVENT,
  payload: data,
});

const analyzeView = (data: Record<string, any>): AnalyzeViewAction => ({
  type: ANALYZE_VIEW,
  payload: data,
});

const analyzeEmmitEventToTealium = (data: Record<string, any>): AnalyzeEmmitEventToTealiumAction => ({
  type: ANALYZE_EMMIT_EVENT_TO_TEALIUM,
  payload: data,
});

const analyzeEmmitViewToTealium = (data: Record<string, any>): AnalyzeEmmitViewToTealiumAction => ({
  type: ANALYZE_EMMIT_VIEW_TO_TEALIUM,
  payload: data,
});

export {
  analyzeEmmitEventToTealium,
  analyzeEmmitViewToTealium,
  analyzeEvent,
  analyzeView,
};
